module.exports = __webpack_public_path__ + "static/media/plan-C1b-desktop-sc.18b54d23.png";